"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Create an accessor that gets the resource as an object
 * @param t An i18next instance.
 */
const createTObj = (t) => 
/**
 * Get the resource as an object
 * @param key The key.
 * @param placeholder The placeholder for i18next.
 */
(key, placeholder) => t(key, { returnObjects: true, ...placeholder });
/**
 * Create the i18n function.
 * @param t An i18next instance.
 */
exports.default = (t) => {
    const tObj = createTObj(t);
    const getDetail = (f, fc = f) => (category) => {
        const get = (func) => (key) => func([category, key !== null && key !== void 0 ? key : 'detail'].join('.'));
        return { getCategoryDetail: get(fc), getByKey: get(f) };
    };
    return {
        tCategoryStringedDetail: getDetail(tObj, t),
        tDetail: getDetail(tObj),
        tObj,
        tStringedDetail: getDetail(t),
    };
};
//# sourceMappingURL=createGenericAccessor.js.map